import React from 'react';
import {HashRouter, Route, Switch} from 'react-router-dom';
import App from "../App";
import {Layout, Spin, Icon, message, Result} from 'antd';
import config from "../config";
import {applicationName, uuid} from "../utils";
import {LOAD_CURRENT_USER, NO_FRAME} from "../constants";
import {connect} from "react-redux";
import {getInfoFromLocalStorage} from "../actions";
import Login from "../containers/login";
import RequestComponent from "../base/RequestComponent";
import {begin} from "../base/auth";
import {findObject} from "../view/editor/floatTool/securityCheck";

const {Content} = Layout;

const isValid = (hash, allHash)=>{
    let findResult = findObject(allHash, "path", hash);
    if(findResult){
        return true;
    }
    if(window.sysConfig){
        //白名单列表，如果当前要跳转的路由没有在该用户配置的菜单中，那么就去匹配白名单，判断是否需要放行
        let menuRouteWhiteList = eval(window.sysConfig.getValueByKey("menu.route.white.list", "['/view/editor/.*', '/view/htmldiff/.*', 'login', '/view/sysManagement/messageCenter', '/view/sysManagement/processCenterUntreated','/view/contentSecurityCenter/details','/view/otherMediaManuscript/details','/view/stationGroupManagement/StationGroupManagement','/view/pms/MediaAdministerBatchAddComponent','/view/newMediaMatrix/pms/newMediaManagement/douYinLink','/view/newMediaMatrix/pms/platformMaintenance/maintenanceField/.*']"));

        for(let i = 0 ; menuRouteWhiteList && i < menuRouteWhiteList.length; i++){
            let routeRegexpStr = menuRouteWhiteList[i];
            let regExp = new RegExp(routeRegexpStr);
            if(regExp.test(hash)){//如果满足一个白名单正则，那么就放行
                return true;
            }
        }
        return false;
    }
    return true;
};
class CmsitesRoute extends RequestComponent {

    state={
        loginStatus: "ing",//ing：增在校验中，true:已经登录成功，error:系统服务启动失败。其他值：未登录
    };

    componentDidMount() {
        this.loginVerify();
    }

    systemInit = ()=>{//登录之后刷新页面系统初始化的方法
        let systemInfoIsLoadOver = this.infoIsLoadOver();
        if(systemInfoIsLoadOver){
            try {
                let {currentUser, currentUser:{id}} = this.getInfo();
                this.props.updateCurrentUserToRedux(currentUser);//将当前用户存放在redux中，系统顶部用户是从redux中读取的，因为修改用户信息时顶部需要跟着联动。
                window.getInfo = this.getInfo;//系统信息存放在window中，供layui界面读取
                begin(id,()=>{
                    this.setState({loginStatus:"true"});
                });
                this.setState({loginStatus:"true"});
            }catch (e) {
                console.error(e);
                message.error("系统初始化完成，但信息获取错误！");
                this.setState({loginStatus:"false"});
            }
        }else{
            this.setState({loginStatus:"true"});
        }
    };

    loginVerify=()=>{
        let token = getInfoFromLocalStorage('Token');
        let haveToken = token ? true : false;
        this.request({
            url: "/cm-sites-sys"+"/islogin",
            method:"post",
            callBack:loginStatus=>{
                this.systemInit();
            },
            errorCallBack: err => {
                console.log("error: ", err);
                this.systemInit();
                // this.setState({loginStatus:"error"});
            },
            serverVerify:{
                serverErrorCallBack: err=>{
                    this.setState({loginStatus:"false"});
                },
                isShowErrorMsg: false
            },
            haveToken
        });
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.systemStatus){
            this.setState({
                loginStatus:nextProps.systemStatus.status
            });
        }
    }

    repairLocationHash = ()=>{
        let currentHash=window.location.hash.replace('#','');
        let navigateData = getInfoFromLocalStorage('menu')||[];//window.cmsitesNavigateData;
        if(navigateData && navigateData.length){
            if(!currentHash || currentHash==='/'){
                window.location.hash=navigateData[0].path;
            }else{
                if(isValid(currentHash, navigateData)){
                    window.location.hash = currentHash;
                }else{
                    message.warn("越权访问，已自动跳转至第一个菜单页面！");
                    window.location.hash=navigateData[0].path;
                }
            }
        }
    };

    render() {
        let loadingDom = <table width={"100%"} height={"100%"}>
            <tbody>
            <tr width={"100%"} height={"100%"}>
                <td width={"100%"} height={"100%"} align={"center"} valign={"middle"}><Spin /></td>
            </tr>
            </tbody>
        </table>;
        let errorDom = <table width={"100%"} height={"100%"}>
            <tbody>
            <tr width={"100%"} height={"100%"}>
                <td width={"100%"} height={"100%"} align={"center"} valign={"middle"}><h1>
                    <Icon type="exclamation-circle" style={{fontSize:30,color:"red",marginRight:10}} />服务器未响应，可能是服务维护中，请稍后重新刷新登录</h1>
                </td>
            </tr>
            </tbody>
        </table>;
        if (this.state.loginStatus === "ing") {
            return loadingDom;
        }
        if (this.state.loginStatus === "error") {
            return errorDom;
        }

        if (this.state.loginStatus !== "true") {
            let search = window.location.search;
            if(search && search.length > 0){
                search = search.substring(1);
            }
            return <Login msg={window.decodeURI(search)}/>;
        }
        this.repairLocationHash();
        let sysConfig = null;
        if(this.getInfo()){
            sysConfig = this.getInfo().config;
        }


        let newSecondSelectColor = sysConfig && sysConfig.getValueByKey ? sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let routeArr = config[applicationName()].route;
        return (
            <>
                <HashRouter>
                    <Switch>
                        {
                            routeArr.map(item => {
                                if (item.framePath && item.framePath.length > 0) {
                                    return <Route key={uuid()} exact path={item.path}
                                                  render={(match) => <CmsitesContent match={match}
                                                                                     path={item.framePath}/>}/>
                                } else {
                                    //pms写稿页面嵌套资源库使用需要适配的
                                    let componentProps = item.componentProps;
                                    if (item.frame===NO_FRAME){
                                        return <Route key={uuid()} exact path={item.path} render={(match)=>{
                                            return <item.component {...match} {...componentProps}/>;
                                        }} />
                                    } else {
                                        return <Route key={uuid()} exact path={item.path} render={(match) => {
                                            try {
                                                this.getInfo();
                                            }catch (e) {
                                                message.error("登录信息失效，请重新登录！",0.5,()=>{
                                                    window.location.href=window.location.origin+'/cm-sites/pms/framereact/index.html'
                                                });
                                               // return <Login msg={"登录信息失效，可能您清理过浏览器缓存！"}/>;
                                            }
                                            let currentHash=window.location.hash.replace('#','');
                                            let navigateData = getInfoFromLocalStorage('menu')||[];//window.cmsitesNavigateData;
                                            if(!navigateData || navigateData.length === 0){
                                                return loadingDom;
                                            }
                                            if(isValid(currentHash, navigateData)){
                                                return <App
                                                    content={<Content style={{background: "#F2F2F2", overflow: "hidden"}}>
                                                        <item.component {...match} {...componentProps}/>
                                                    </Content>}/>
                                            }else{
                                                window.location.hash=navigateData[0].path;
                                                return ''
                                                return <table width={"100%"} height={"100%"} cellPadding={0} cellSpacing={0} border={0}><tbody><tr><td valign={"middle"} align={"center"}><Result
                                                    status="error"
                                                    title="您无权访问该页面！"
                                                /></td></tr></tbody></table>
                                            }
                                        }}/>
                                    }
                                }

                            })
                        }
                    </Switch>
                </HashRouter>
                <style>
                    {
                        ` .ant-pagination-item-active{
                      border-color: ${newSecondSelectColor} !important;
                  }
                  .ant-pagination-item-active a{
                    color: ${newSecondSelectColor} !important;
                  }
                  .ant-pagination-item:hover{
                    border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-pagination-item:hover a{
                       color: ${newSecondSelectColor} !important;
                        }
                    .ant-pagination-item-link:hover{
                        color:  ${newSecondSelectColor} !important;
                        border-color:  ${newSecondSelectColor} !important;
                    }
                    .ant-select-open .ant-select-selection{
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-select-selection:active, .ant-select-selection:focus, .ant-select-selection:hover{
                        border-color: ${newSecondSelectColor} !important;
                        box-shadow: none;
                        -webkit-box-shadow:none;

                    }
                    input:focus,input:hover{
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-input:focus, input:focus{
                        box-shadow: none !important;
                        -webkit-box-shadow:none !important;
                    }
                    .ant-select-dropdown-menu-item-active{
                        background-color:${newSecondSelectColor} !important;
                        color: #fff !important;

                    }
                    .ant-select-dropdown-menu-item-selected{
                        background-color:${newSecondSelectColor} !important;
                        opacity: 0.8;
                        color: #fff;
                    }
                    .ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected{
                        background-color:${newSecondSelectColor} !important;
                        color: #fff;
                    }
                    .cm-link {
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-select-tree li .ant-select-tree-node-content-wrapper:hover{
                        background-color:${newSecondSelectColor} !important;
                        color: #fff;
                    }
                    
                    .ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled), .ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled){
                        border-color: ${newSecondSelectColor} !important;
                        box-shadow: none !important;
                        -webkit-box-shadow:none !important;
                    }
                    .ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date, .ant-calendar-selected-end-date .ant-calendar-date{
                        background: ${newSecondSelectColor} !important;
                        color: #fff !important;
                    }
                    .ant-calendar-today .ant-calendar-date{
                        color:  ${newSecondSelectColor} !important;
                        border-color:  ${newSecondSelectColor} !important;
                    }
                    .ant-calendar-range .ant-calendar-in-range-cell::before{
                        background: ${newSecondSelectColor} !important;
                        opacity:0.6;
                        color: #fff !important;
                    }
                    .ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date{
                        color:#fff !important;
                    }
                    .ant-calendar-date:hover{
                        color: #fff !important;
                        background: ${newSecondSelectColor} !important;
                    }
                    .ant-calendar-selected-day .ant-calendar-date{
                        background: ${newSecondSelectColor} !important;
                        color: #fff !important;
                    }
                    .ant-calendar-time-picker-btn{
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-calendar .ant-calendar-ok-btn,  .ant-calendar .ant-calendar-ok-btn:hover{
                        background-color:${newSecondSelectColor};
                        border-color:  ${newSecondSelectColor} !important;
                        color: #fff;
                    }
                    .ant-btn {
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-btn-dashed:hover{
                        color: ${newSecondSelectColor} !important;
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn{
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-btn:hover, .ant-btn:focus{
                        color: ${newSecondSelectColor} ;
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-btn-primary:hover, .ant-btn-primary:focus{
                        color:#fff !important;
                    }
                    .ant-btn-primary{
                        background: ${newSecondSelectColor} !important;
                        border-color: ${newSecondSelectColor} !important;
                        color:#fff !important;
                    }
                     .ant-btn-danger{
                        color:#fff !important;
                    }
                    .ant-input{border-color: rgb(217, 217, 217) !important;}
                    .ant-input:focus, .ant-input:hover{border-color:${newSecondSelectColor} !important;}
                   .ant-tabs-tab-active {
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-input-number{border-color: rgb(217, 217, 217) !important;}
                    .ant-input-number:focus, .ant-input-number:hover{border-color:${newSecondSelectColor} !important;}
                    
                    .ant-upload{border-color: rgb(217, 217, 217) !important;}
                    .ant-upload:focus, .ant-upload:hover{border-color:${newSecondSelectColor} !important;}
                    .ant-checkbox-indeterminate .ant-checkbox-inner::after{background-color:${newSecondSelectColor} !important;}
                    .ant-tree-checkbox{border-color: rgb(217, 217, 217) !important;}
                    .ant-tree-checkbox-inner:focus, .ant-tree-checkbox-inner:hover{border-color:${newSecondSelectColor} !important;}
                    .ant-tree-checkbox-checked::after{border-color:${newSecondSelectColor} !important;}
                    .ant-checkbox-checked::after{border-color:${newSecondSelectColor} !important;}
                    // ..ant-switch-checked{background-color:${newSecondSelectColor} !important;}
                   .ant-tabs-tab-active {
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon, .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon{color:${newSecondSelectColor}}
                   .ant-tabs-nav .ant-tabs-tab:hover {
                        color: ${newSecondSelectColor} !important;
                    }
                    .ant-tabs-ink-bar{
                    background-color:${newSecondSelectColor} !important;
                    }
                    .ant-checkbox-checked .ant-checkbox-inner{
                        background-color: ${newSecondSelectColor} !important;
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner {
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-radio-button-wrapper-checked{
                     color: ${newSecondSelectColor} !important;
                        border-color: ${newSecondSelectColor} !important;
                    }
                     .ant-radio-button-wrapper:hover{
                     color: ${newSecondSelectColor} !important;
                    }
                    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
                        -webkit-box-shadow: -1px 0 0 0 ${newSecondSelectColor};
                        box-shadow: -1px 0 0 0 ${newSecondSelectColor};
                    }
                    .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value, .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value
                    {
                     color: ${newSecondSelectColor} !important;
                    }
                    .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date
                    {
                        border-top-color: ${newSecondSelectColor} !important;
                    }
                    .ant-radio-checked .ant-radio-inner{
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-radio:hover{
                        border-color: ${newSecondSelectColor} !important;
                    }
                    .ant-radio-inner::after{
                        background-color: ${newSecondSelectColor} !important;
                    }
                    .ant-tree-checkbox-checked .ant-tree-checkbox-inner{
                        border-color: ${newSecondSelectColor} !important;
                        background-color: ${newSecondSelectColor} !important;
                    }
                    .ant-tabs-tab-active{color:${newSecondSelectColor} !important;}
                     .ant-tabs-tab:hover{color:${newSecondSelectColor} !important;}
                     .ant-tabs-ink-bar{background-color:${newSecondSelectColor} !important;}
                     .ant-btn-danger :hover , .ant-btn-danger:focus{
                     color:#fff !important
                     }
                     .ant-switch-checked {
                        background-color: ${newSecondSelectColor} !important;
                     }
                     .ant-modal-footer {
                        text-align:center !important;
                     }
                      .ant-btn-link:hover, .ant-btn-link:focus{
                        color: ${newSecondSelectColor} ;
                        border-color: transparent !important;
                    }
                    .ant-notification{
                    z-index:1000000
                    }
                    .ant-notification-close-icon{
                    position: absolute;
                    top:"0px"
                    }
                    .ant-notification-notice-content{
                    transform: translateY(7px);
                    }
                    .ant-notification-notice-description a{
                    word-wrap: break-word;
                    }
                     .ant-message{
                    top: 93px !important;
                    }
                  `
                    }
                </style>

            </>
        );
    }
}

let updateCurrentUserToRedux = (user) => ({type: LOAD_CURRENT_USER,currentUser: user});

function mapStateToProps(state){
    return {
        config: state.systemReducer.config,
        // navigateData: state.systemReducer.navigateData,
        systemStatus: state.systemReducer.systemStatus,
    }
}

export default connect(mapStateToProps, {updateCurrentUserToRedux})(CmsitesRoute);

class CmsitesContent extends React.Component {

    render() {
        let params = "";
        if (this.props.match.match) {
            for (let key in this.props.match.match.params) {
                if (this.props.match.match.params[key]) {
                    if (params === "") {
                        params = "?" + key + "=" + this.props.match.match.params[key];
                    } else
                        params += "&" + key + "=" + this.props.match.match.params[key];
                }
            }
        }
        if (this.props.path && this.props.path.indexOf("?") !== -1) {
            params = params.replace("?", "&");
        }

        return <App content={<Content style={{background: "#f4f6fc", overflow: "hidden",lineHeight:"0"}}>
            <iframe title={"内容区域"} style={{height: "calc(100vh - 70px)", width:"100%", margin: "0px"}} allowFullScreen={true} frameBorder={0}
                    src={this.props.path + params}/>
        </Content>}/>
    }
}